export enum NegotiationStatusEnum {
  ACTIONABLE = 'actionable',
  PENDING = 'pending',
  COMPLETED = 'completed',
}

export interface NegotiationAPIResponse {
  category_name: string
  mp_fk_usr_id: number
  mp_id: number
  mp_min_size: number | null
  mp_potency: string
  mp_qty: number
  mp_type: string
  mt_ctpty_fk_usr_id: number
  mt_currency: string
  mt_date_updated: string
  mt_fk_prd_id: number
  mt_fk_usr_id: number
  mt_id: number
  mt_min_size: number | null
  mt_potency: number
  mt_price: number
  mt_product_name: string
  mt_qty: number
  mt_qty_type: string
  mt_status: string
  mt_type: string
  total_count: string
}

export interface Negotiation {
  id: number
  userID: number
  counterpartyUserID: number
  productName: string
  categoryName: string
  interestId: number
  transactionId: number
  transactionDate?: string
  transactionType?: string
  potency?: string
  transactionPrice?: number
  transactionPriceCurrency?: string
  transactionQty?: number
  transactionQtyType: string
  tradeUserID?: number
}

export const toNegotiation = (apiResponse: NegotiationAPIResponse): Negotiation => ({
  id: apiResponse.mt_id,
  userID: apiResponse.mp_fk_usr_id,
  counterpartyUserID: apiResponse.mt_ctpty_fk_usr_id,
  productName: apiResponse.mt_product_name,
  categoryName: apiResponse.category_name,
  interestId: apiResponse.mp_id,
  transactionId: apiResponse.mt_id,
  transactionDate: apiResponse.mt_date_updated,
  transactionType: apiResponse.mt_type,
  potency: apiResponse.mp_potency,
  transactionPrice: apiResponse.mt_price,
  transactionPriceCurrency: apiResponse.mt_currency,
  transactionQty: apiResponse.mt_qty,
  transactionQtyType: apiResponse.mt_qty_type,
  tradeUserID: apiResponse.mt_fk_usr_id,
})
